import {Form} from 'antd'
import {InputNumber} from '@/components/Form/index.mjs'
import {Prompt, useOpenModal} from '@/components/Modal/index.mjs'
import {useRunWorkflow} from '@/biz/workflow.jsx'

export const aiAnalyseWorkload = () => () => {
    const openModal = useOpenModal()
    const runWorkflow = useRunWorkflow()

    return async function () {
        const formValue = await openModal(
            <Prompt
                title="输入产出效率（FP/人天）"
                value={{prodEf: 1.5}}
            >
                <Form.Item name="prodEf">
                    <InputNumber />
                </Form.Item>
            </Prompt>
        )

        if (! formValue) {
            return
        }

        const {prodEf} = formValue

        if (! prodEf) {
            return
        }

        const {prjId, prjPatternId, sVer, prjName, prjNo} = this.data

        const bizMap = {
            patternId: prjPatternId,
            prjId,
            prodEf: String(prodEf),
            sVer,
            prjName,
            prjNo
        }

        runWorkflow({bizMap, scene: 'GENERATE_SMA'})
    }
}
